import { useTranslation } from 'react-i18next'
import { M_Fieldset } from 'src/M_Components'
import { ShipmentChargesFormField } from './ShipmentChargesFormField'

export const ShipmentChargesClass = ({ dataState, setDataState, disabled, style }) => {
    const { t } = useTranslation()

    const rateClassOptions = [
        { label: 'Minimum', value: 'M' },
        { label: 'Normal', value: 'N' },
        { label: 'Quantity', value: 'Q' },
        { label: 'Commodity', value: 'C' },
        { label: 'Reduction', value: 'R' },
        { label: 'Surcharge', value: 'S' },
    ]

    const classFields = [
        {
            display: t('RateClass'),
            code: 'RateClass',
            type: 'select',
            options: rateClassOptions,
        },
    ]

    return (
        <M_Fieldset
            labelInside
            style={{ width: '100%', boxSizing: 'border-box', ...style }}
            label={
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '20px', marginLeft: '10px' }}>
                    <i className='pi pi-th-large' style={{ fontSize: '18px' }} />
                    {t('Class')}
                </div>
            }
            elements={
                <div style={{ display: 'flex', flexWrap: 'wrap', padding: '10px' }}>
                    {classFields.map((field, index) => (
                        <ShipmentChargesFormField
                            key={index}
                            fields={field}
                            index={index}
                            data={dataState}
                            setData={setDataState}
                            options={field.options}
                            disabled={disabled}
                        />
                    ))}
                </div>
            }
        />
    )
}
